import React, { PropsWithChildren } from 'react';

import classes from './FloatTooltip.module.scss';

interface Props extends PropsWithChildren {
    label: string;
    visible?: boolean;
}

export const FloatTooltip = ({ children, label, visible = true }: Props) => {
    if (!visible) {
        return <>{children}</>;
    }

    return (
        <div className={classes.root}>
            <div className={classes.pill}>{label}</div>
            {children}
        </div>
    );
};
